import img1 from '../images/Rectangle 111.png';
// import orangeStar from '../images/OrangeStar.png';

const CustomerReview = [
  {
    id: 1,
    name: 'Kenny Anos',
    date: 'November 14, 2023',
    lastSeen: '2 weeks ago',
    reviewHeading: 'The technician was easy to communicate with',
    reviewParagraph:
      'Communication was a breeze! Clear and effective communication made the entire repair process smooth and hassle-free.',
  },
  {
    id: 2,
    img: img1,
    name: 'Tobi Ajani',
    date: 'November 14, 2023',
    lastSeen: '2 weeks ago',
    reviewHeading: 'The technician was easy to communicate with',
    reviewParagraph:
      'Communication was a breeze! Clear and effective communication made the entire repair process smooth and hassle-free.',
  },
  {
    id: 3,
    img: img1,
    name: 'Chukwudi Agu',
    date: 'November 14, 2023',
    lastSeen: '2 weeks ago',
    reviewHeading: 'The technician was easy to communicate with',
    reviewParagraph:
      'Communication was a breeze! Clear and effective communication made the entire repair process smooth and hassle-free.',
  },
  {
    id: 4,
    img: img1,
    name: 'Chukwu Alex',
    date: 'November 14, 2023',
    lastSeen: '2 weeks ago',
    reviewHeading: 'The technician was easy to communicate with',
    reviewParagraph:
      'Communication was a breeze! Clear and effective communication made the entire repair process smooth and hassle-free.',
  },
];

export default CustomerReview;
